import React from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';

import Blockquotes from './assets/blockquotes.svg';
import colors from '@magoosh/lib/styles/colors.module.scss';
import styles from './style.module.scss';

interface QuoteCardProps {
  children: any;
  className?: string;
  image?: {
    alt?: string;
    height?: string;
    onClick?: () => void;
    src?: string;
    width?: string;
  };
  studentAffiliation: string;
  studentName: string;
}

export const QuoteCard = (props: QuoteCardProps) => {
  return (
    <Card className={cx(props.className, { 'd-flex flex-column flex-lg-row gap-m gap-lg-l': !!props.image })}>
      {
        props.image && (
          <div>
            <img
              className={styles.quoteCardImage}
              loading="lazy" {...props.image}
              style={{ cursor: props.image.onClick ? 'pointer': 'initial' }}
            />
          </div>
        )
      }

      <div className="flex-1" style={{ position: 'relative' }}>
        <div style={{ bottom: 20, position: 'absolute', right: 20 }}>
          <img
            alt="Large quotes"
            src={Blockquotes}
          />
        </div>

        <div className="d-flex flex-1 flex-column gap-m">
          <div className={cx(styles.quoteCardQuote, 'text-inter text-medium')}>
            {props.children}
          </div>

          <div className="text-inter" style={{ fontSize: 13 }}>
            <div className="text-medium">{props.studentName}</div>
            <div style={{ color: '#5C5C5C' }}>{props.studentAffiliation}</div>
          </div>
        </div>
      </div>
    </Card>
  );
};

interface QuoteCardWithScoresProps {
  children: any;
  className?: string;
  examSections: {
    name: string;
    score: number;
  }[];
  skewAngle?: number;
  studentName: string;
}

export const QuoteCardWithScores = (props: QuoteCardWithScoresProps) => {
  const examSectionColors = [
    '#B674FF',
    colors.brandSecondary
  ];

  return (
    <Card className={cx(props.className, 'flex-1')} skewAngle={props.skewAngle}>
      <div className="d-flex flex-column gap-s">
        <div><strong>{props.studentName}</strong></div>

        <div className="d-flex gap-m">
          {
            props.examSections.map((examSection, idx) => (
              <div key={examSection.name} className="small">
                {examSection.name}
                <span
                  style={{
                    background: examSectionColors[idx],
                    borderRadius: 6,
                    color: '#fff',
                    fontWeight: 600,
                    marginLeft: 10,
                    padding: '3px 6px'
                  }}
                >
                  {examSection.score}
                </span>
              </div>
            ))
          }
        </div>
      </div>

      <div className="small" style={{ lineHeight: 1.75, marginTop: 20 }}>
        {props.children}
      </div>
    </Card>
  );
};

interface QuoteCardWithScoreImprovementsProps {
  children: any;
  className?: string;
  examSections: {
    name: string;
    score: number;
    scoreIncrease: number;
  }[];
  studentAvatar: string;
  studentName: string;
}

export const QuoteCardWithScoreImprovements = (props: QuoteCardWithScoreImprovementsProps) => {
  return (
    <Card className={cx(props.className, 'd-flex flex-column gap-m')}>
      <div className="align-items-center d-flex flex-row gap-s">
        <div>
          <img alt={`Image of ${props.studentName}`} height="56px" src={props.studentAvatar} width="56px" />
        </div>

        <div className="text-inter"><strong>{props.studentName}</strong></div>
      </div>

      <div className="flex-1" style={{ position: 'relative' }}>
        <div className="hidden-xs hidden-sm" style={{ bottom: -30, position: 'absolute', right: 0 }}>
          <img
            alt="Large quotes"
            src={Blockquotes}
          />
        </div>

        <div className={cx(styles.quoteCardQuote, 'text-inter text-medium')}>
          {props.children}
        </div>
      </div>

      <div className="u-margin-T-s">
        <table className={styles.quoteCardScoreIncreaseTable} style={{ width: '100%' }}>
          <tbody>
            {
              props.examSections.map((examSection) => (
                <tr className="small text-inter" key={examSection.name}>
                  <td>{examSection.name}</td>
                  <td style={{ color: '#B674FF' }} width="50">
                    <strong>{examSection.score}</strong>
                  </td>
                  <td style={{ color: '#472375' }} width="150">
                    +{examSection.scoreIncrease} Point Increase
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </Card>
  );
};
